import { render, staticRenderFns } from "./PersonalLarge.vue?vue&type=template&id=155bc82e&"
import script from "./PersonalLarge.vue?vue&type=script&lang=js&"
export * from "./PersonalLarge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports